import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "shipping-providers row" }
const _hoisted_2 = { class: "col-12 col-md-6 q-pr-xl provider-select" }
const _hoisted_3 = {
  class: "header row",
  style: {"justify-content":"space-between"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "items-list__list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "items-list__item-title bold" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "bold" }
const _hoisted_10 = { class: "items-list__item-tag" }
const _hoisted_11 = {
  key: 0,
  class: "notice small inline dense info has-tooltip notice--private-tag space-h1",
  "data-tooltip": "This provider is available to your Directify space through a custom contract"
}
const _hoisted_12 = { class: "col-md-6 q-pl-xl account-list" }
const _hoisted_13 = {
  key: 0,
  class: "item-details__container"
}
const _hoisted_14 = { class: "item-details__container-section items-list__list" }
const _hoisted_15 = {
  key: 0,
  class: "bold item-details__section-title"
}
const _hoisted_16 = { class: "bold" }
const _hoisted_17 = {
  key: 2,
  class: "placeholder item-details__section-placeholder"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "notice inline dense warn item-details__section-item-tag"
}
const _hoisted_20 = { class: "item-details__section-item-title items-list__item-title" }
const _hoisted_21 = {
  key: 0,
  class: "item-details__section-item-expanded"
}
const _hoisted_22 = { class: "item-details__auth-data space-v2" }
const _hoisted_23 = { class: "item-details__auth-data-head" }
const _hoisted_24 = { class: "bold" }
const _hoisted_25 = { class: "item-details__auth-data-actions" }
const _hoisted_26 = {
  key: 0,
  class: "item-details__auth-content"
}
const _hoisted_27 = {
  key: 0,
  class: "item-details__auth-content-inner--static"
}
const _hoisted_28 = { class: "item-details__auth-content-user" }
const _hoisted_29 = { class: "item-details__auth-content-pass" }
const _hoisted_30 = {
  key: 1,
  class: "item-details__auth-content-inner"
}
const _hoisted_31 = {
  key: 1,
  class: "item-details__auth-content"
}
const _hoisted_32 = {
  key: 0,
  class: "item-details__auth-content-inner--static"
}
const _hoisted_33 = { class: "item-details__auth-content-user" }
const _hoisted_34 = { class: "item-details__auth-content-pass" }
const _hoisted_35 = {
  key: 1,
  class: "item-details__auth-content-inner"
}
const _hoisted_36 = {
  key: 2,
  class: "item-details__auth-content"
}
const _hoisted_37 = {
  key: 1,
  class: "item-details__auth-content-inner"
}
const _hoisted_38 = {
  key: 0,
  class: "item-details__section-item-config"
}
const _hoisted_39 = {
  key: 1,
  class: "item-details__section-item-config-placeholder"
}
const _hoisted_40 = { class: "item-details__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_d_form = _resolveComponent("d-form")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Shipping carriers", -1)),
        _createVNode(_component_q_btn, {
          class: "carrier-btn",
          unelevated: "",
          rounded: "",
          color: "primary"
        }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("span", { style: {"font-weight":"600 !important"} }, "Add Carrier ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "t-icon lowercase bold" }, "d", -1)),
            _createVNode(_component_q_menu, {
              offset: [5,5],
              anchor: "bottom left",
              "transition-duration": "100",
              "auto-close": "",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SHIPMENT_SERVICES, (option) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    onClick: _withModifiers(($event: any) => (_ctx.draftProvider(option.value)), ["stop"]),
                    clickable: ""
                  }, {
                    default: _withCtx(() => [
                      (option.icon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: option.icon,
                            style: {"margin-right":"7px"},
                            width: "20"
                          }, null, 8, _hoisted_4))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(option.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_close_popup]
                  ])
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carrierServicesByType, (carrierServices, type) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["items-list__item", { active: _ctx.active === type }]),
            onClick: ($event: any) => (_ctx.setActive(type))
          }, [
            _createElementVNode("h4", _hoisted_7, [
              (_ctx.SHIPMENT_CARRIER_DICT[type]?.icon)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "items-list__item-icon display-inline",
                    src: _ctx.SHIPMENT_CARRIER_DICT[type]?.icon,
                    width: "20",
                    style: {"margin-right":"10px"}
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.SHIPMENT_CARRIER_DICT[type]?.label || type), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(carrierServices.length) + " " + _toDisplayString(carrierServices.length === 1 ? 'service' : 'services'), 1),
              (_ctx.SHIPMENT_CARRIER_DICT[type]?.private)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Private"))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_6))
        }), 256))
      ])
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.carrierServicesByType[_ctx.active])
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carrierServicesByType[_ctx.active], (cs) => {
              return (_openBlock(), _createElementBlock("section", _hoisted_14, [
                (!cs.service.draft && !cs.service.rename)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.format.title(_ctx.carriers.find(c => c.service === cs.service.id)?.name || '') || _ctx.format.title(cs.service.name || '') || cs.service.id), 1),
                      _createVNode(_component_q_btn, {
                        flat: "",
                        dense: "",
                        round: "",
                        onClick: ($event: any) => (cs.service.rename = true)
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("div", { class: "t-icon" }, "P", -1)
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  : (_openBlock(), _createBlock(_component_q_input, {
                      key: 1,
                      autofocus: "",
                      outlined: "",
                      dense: "",
                      rounded: "",
                      "model-value": _ctx.carriers.find(c => c.service === cs.service.id)?.name || cs.service.name,
                      "onUpdate:modelValue": ($event: any) => (_ctx.setCarrierServiceName(cs.service.id, $event)),
                      onKeydown: _withKeys(() => { cs.service.rename = false; _ctx.updateCarrierServiceName(cs.service.id, _ctx.carriers.find(c => c.service === cs.service.id)?.name || cs.service.name) }, ["enter"])
                    }, null, 8, ["model-value", "onUpdate:modelValue", "onKeydown"])),
                (!cs.accounts?.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_17, _cache[8] || (_cache[8] = [
                      _createElementVNode("span", null, "Service has no accounts yet", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1)
                    ])))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(cs.accounts, (account) => {
                      return (_openBlock(), _createElementBlock("section", {
                        class: _normalizeClass(["item-details__section-item items-list__item no-hover", `${_ctx.expanded.includes(account.id) ? 'expanded' : 'collapsed'}`])
                      }, [
                        _createElementVNode("div", {
                          class: "item-details__section-item-head",
                          onClick: _withModifiers(($event: any) => (_ctx.toggleExpandItem(account.id)), ["stop"])
                        }, [
                          (account.draft)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Draft"))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(account.meta?.type ? _ctx.format.title(`${account.meta?.type} account`) : account.id), 1)
                        ], 8, _hoisted_18),
                        (_ctx.expanded.includes(account.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.SHIPMENT_SERVICE_AUTH_TYPE[cs.service.type][account.type || 'default'] === 'basicauth' ? 'Username & Password' : _ctx.SHIPMENT_SERVICE_AUTH_TYPE[cs.service.type][account.type || 'default'] === 'oauth' ? 'OAuth credentials' : 'API Key'), 1),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      rounded: "",
                                      onClick: ($event: any) => (_ctx.verifyAuth(cs.service.id, account, cs.service.draft ? cs.service.type : undefined))
                                    }, {
                                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                                        _createElementVNode("div", { class: "t-icon" }, _toDisplayString('>'), -1),
                                        _createElementVNode("span", null, "Verify", -1)
                                      ])),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    (_ctx.editingAuth !== account.id)
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 0,
                                          flat: "",
                                          rounded: "",
                                          onClick: ($event: any) => (_ctx.editAuthWarn(account))
                                        }, {
                                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createElementVNode("div", { class: "t-icon" }, "P", -1),
                                            _createElementVNode("span", null, "Edit", -1)
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 1,
                                          class: "error",
                                          flat: "",
                                          round: "",
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingAuth = '')),
                                          color: "error"
                                        }, {
                                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                                            _createElementVNode("div", { class: "t-icon error lowercase" }, "j", -1)
                                          ])),
                                          _: 1
                                        }))
                                  ])
                                ]),
                                (_ctx.SHIPMENT_SERVICE_AUTH_TYPE[cs.service.type][account.type || 'default'] === 'basicauth')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      (_ctx.editingAuth !== account.id)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            _createElementVNode("div", _hoisted_28, _toDisplayString(account.basic_auth?.user), 1),
                                            _createElementVNode("div", _hoisted_29, _toDisplayString(account.basic_auth?.pass ? '°°°°°°°°°°' : '...'), 1)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            _createVNode(_component_q_input, {
                                              dense: "",
                                              rounded: "",
                                              outlined: "",
                                              "model-value": account.basic_auth?.user,
                                              "onUpdate:modelValue": ($event: any) => (_ctx.setAccountBasicAuth(cs.service.id, account.id, 'user', $event)),
                                              label: "Username"
                                            }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                            _createVNode(_component_q_input, {
                                              dense: "",
                                              rounded: "",
                                              outlined: "",
                                              "model-value": account.basic_auth?.pass,
                                              "onUpdate:modelValue": ($event: any) => (_ctx.setAccountBasicAuth(cs.service.id, account.id, 'pass', $event)),
                                              label: "Password",
                                              type: "password"
                                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                                          ]))
                                    ]))
                                  : (_ctx.SHIPMENT_SERVICE_AUTH_TYPE[cs.service.type][account.type || 'default'] === 'oauth')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        (_ctx.editingAuth !== account.id)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["item-details__auth-content-clientid", {placeholder: !account.token?.code}])
                                              }, _toDisplayString(account.token?.code ? (account.token?.code) : 'No Client ID set'), 3),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["item-details__auth-content-token", {placeholder: !account.token?.access_token}])
                                              }, _toDisplayString(account.token?.access_token ? (_ctx.revealingAuth ? account.token?.access_token : '°°°°°°°°°°') : 'No key configured'), 3),
                                              _createElementVNode("div", _hoisted_33, _toDisplayString(account.basic_auth?.user), 1),
                                              _createElementVNode("div", _hoisted_34, _toDisplayString(account.basic_auth?.pass ? '°°°°°°°°°°' : ''), 1)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                              _createVNode(_component_q_input, {
                                                dense: "",
                                                rounded: "",
                                                outlined: "",
                                                "model-value": account.token?.code,
                                                "onUpdate:modelValue": ($event: any) => (_ctx.setAccountCode(cs.service.id, account.id, $event)),
                                                label: "Client ID"
                                              }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                              _createVNode(_component_q_input, {
                                                dense: "",
                                                rounded: "",
                                                outlined: "",
                                                "model-value": account.token?.access_token,
                                                "onUpdate:modelValue": ($event: any) => (_ctx.setAccountToken(cs.service.id, account.id, $event)),
                                                type: "password",
                                                label: "Client Secret"
                                              }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                              _createVNode(_component_q_input, {
                                                dense: "",
                                                rounded: "",
                                                outlined: "",
                                                "model-value": account.basic_auth?.user,
                                                "onUpdate:modelValue": ($event: any) => (_ctx.setAccountBasicAuth(cs.service.id, account.id, 'user', $event)),
                                                label: "Username"
                                              }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                              _createVNode(_component_q_input, {
                                                dense: "",
                                                rounded: "",
                                                outlined: "",
                                                "model-value": account.basic_auth?.pass,
                                                "onUpdate:modelValue": ($event: any) => (_ctx.setAccountBasicAuth(cs.service.id, account.id, 'pass', $event)),
                                                label: "Password",
                                                type: "password"
                                              }, null, 8, ["model-value", "onUpdate:modelValue"])
                                            ]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        (_ctx.editingAuth !== account.id)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "item-details__auth-content-inner--static",
                                              onMousedown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.revealingAuth=true)),
                                              onMouseup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.revealingAuth=false))
                                            }, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass({placeholder: !account.token?.access_token})
                                              }, _toDisplayString(account.token?.access_token ? (_ctx.revealingAuth ? account.token?.access_token : '°°°°°°°°°°') : 'No key configured'), 3)
                                            ], 32))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                              _createVNode(_component_q_input, {
                                                dense: "",
                                                rounded: "",
                                                outlined: "",
                                                "model-value": account.token?.access_token,
                                                "onUpdate:modelValue": ($event: any) => (_ctx.setAccountToken(cs.service.id, account.id, $event)),
                                                type: "password"
                                              }, null, 8, ["model-value", "onUpdate:modelValue"])
                                            ]))
                                      ]))
                              ]),
                              (_ctx.SHIPPING_CARRIER_CONFIGS[cs.service.type])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createVNode(_component_d_form, {
                                      title: "Settings",
                                      template: _ctx.SHIPPING_CARRIER_CONFIGS[cs.service.type],
                                      "model-value": account.meta || {},
                                      "onUpdate:modelValue": ($event: any) => (_ctx.setProviderAccountMeta(cs.service.id, cs.service.type, account.id, $event)),
                                      onConfirm: ($event: any) => (account.draft ? undefined : _ctx.saveProviderAccount(cs.service.id, cs.service.type, account))
                                    }, null, 8, ["template", "model-value", "onUpdate:modelValue", "onConfirm"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_39, "Service has no account configuration options")),
                              _createElementVNode("div", _hoisted_40, [
                                (account.draft || _ctx.editingAuth)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 0,
                                      unelevated: "",
                                      rounded: "",
                                      color: "primary",
                                      onClick: _withModifiers(($event: any) => (_ctx.saveProviderAccount(cs.service.id, cs.service.type, account)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "t-icon lowercase" }, "e", -1)),
                                        _createElementVNode("span", null, _toDisplayString(account.draft ? 'Create' : 'Save'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_q_btn, {
                                  unelevated: "",
                                  rounded: "",
                                  outline: !account.draft,
                                  class: _normalizeClass({ error: !account.draft }),
                                  color: account.draft ? 'grey' : 'error',
                                  onClick: _withModifiers(($event: any) => (_ctx.deleteProviderAccount(cs.service.id, account.id, account.draft)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["t-icon", { error: !account.draft, 'on-color': account.draft, lowercase: account.draft }])
                                    }, _toDisplayString(account.draft ? 'j' : 'B'), 3),
                                    _createElementVNode("span", null, _toDisplayString(account.draft ? 'Cancel' : 'Delete Account'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["outline", "class", "color", "onClick"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 256)),
                (!cs.accounts?.length || !Object.keys(_ctx.SHIPPING_CARRIER_ACCOUNT_CONFIGS[cs.service.type]).every(t => t === 'default' || Object.keys(cs.accounts || {}).includes(t)))
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      unelevated: "",
                      rounded: "",
                      outline: ""
                    }, {
                      default: _withCtx(() => [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "t-icon lowercase" }, "k", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Account", -1)),
                        _createVNode(_component_q_menu, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.SHIPPING_CARRIER_ACCOUNT_CONFIGS[cs.service.type]).filter(t => !Object.keys(cs.accounts || {}).includes(t)), ([key, item]) => {
                              return (_openBlock(), _createBlock(_component_q_item, {
                                onClick: _withModifiers(($event: any) => (_ctx.draftProviderAccount(cs.service.id, cs.service.type, key)), ["stop"]),
                                clickable: "",
                                offset: [10,10],
                                anchor: "bottom left",
                                "transition-duration": "100",
                                "auto-close": ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.type), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 256))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}